import { createSlice } from "@reduxjs/toolkit";

// Create a slice for stocks
const stockSlice = createSlice({
  name: "stock",
  initialState: {
    stockItems: [],
    stock: {},
    loading: false,
    error: null,
  },
  reducers: {
    setStockItems: (state, action) => {
      state.stockItems = action.payload.data || [];
      state.loading = false;
    },
    setStock: (state, action) => {
      state.stock = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectStockLoading = (state) => state.stock.loading;
export const selectStockError = (state) => state.stock.error;
export const selectStockItems = (state) => state.stock.stockItems;
export const selectStock = (state) => state.stock.stock;

// Export the reducer to include in the store
export const { setStock, setStockItems } = stockSlice.actions;
export default stockSlice.reducer;
